import _Button from '@design-system/components/atoms/Button/_Button'
import clsx from 'clsx'
import { observer } from 'mobx-react'
import type { ChangeEvent, FC } from 'react'
import { useState } from 'react'
import { Chip } from 'src/component/molecules/Chip'
import { Radio } from 'src/component/molecules/Radio'
import AcademyOptionsService from 'src/page/etc/MyPage/MyInfo/AcademyOptionsManage/_service/AcademyOptionsService'

import { Icon } from '@/component/atoms/Icon'
import useRepository from '@/hooks/useRepository'
import commonRepo from '@/repository/common.repo'
import modalService from '@/service/modal.service'

import S from './CustomerTypeChangeModal.style'

type CustomerType = 'B2B-학원' | 'B2B-공부방/교습소' | 'B2B-과외' | '기타'
interface CustomerTypeItem {
  key: CustomerType
  label: string
}

const CUSTOMER_TYPE_LIST: CustomerTypeItem[] = [
  {
    key: 'B2B-학원',
    label: '학원',
  },
  {
    key: 'B2B-공부방/교습소',
    label: '공부방 / 교습소',
  },
  {
    key: 'B2B-과외',
    label: '과외',
  },
  {
    key: '기타',
    label: '기타',
  },
]

const CustomerTypeChangeModal: FC = () => {
  const service = useRepository(AcademyOptionsService)
  const [newCustomerType, setNewCustomerType] = useState<CustomerType | undefined>()

  if (!commonRepo.academy?.needCustomerTypeChange) {
    modalService.closeModal()
    return null
  }

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    const value = e.currentTarget.value
    setNewCustomerType(value as CustomerType)
  }

  const handleClick = async () => {
    if (!newCustomerType) {
      return
    }
    await service.modifyAcademyCustomerType(newCustomerType)
    modalService.closeModal()
  }

  return (
    <div css={S}>
      <div className="icon">
        <Icon name="report_notification" size={36} />
      </div>
      <div className="info">잠깐! 꼭 선택해주세요.</div>
      <div className="text">선생님별 맞춤 서비스를 제공하기 위해 운영형태를 선택해주세요.</div>
      <Radio.Group name="customerTypeChangeGroup" onChange={handleChange} className="list">
        {CUSTOMER_TYPE_LIST.map((item) => (
          <div key={item.key}>
            <Chip.Choice
              value={item.key}
              width={272}
              className={clsx('item', { selected: item.key === newCustomerType })}
            >
              {item.label}
            </Chip.Choice>
          </div>
        ))}
      </Radio.Group>
      <div className="action">
        <_Button
          theme="primary"
          size="m"
          width={144}
          disabled={!newCustomerType}
          className="confirm"
          onClick={handleClick}
        >
          확인
        </_Button>
      </div>
    </div>
  )
}

export default observer(CustomerTypeChangeModal)
